export enum CookieEnum {
  SupplementCourse = 'SupplementCourse',
  SupplementCourseLifeTimeYears = 10,
  CustomerID = 'CustomerID',
}
